import axiosClient from './axiosClient';

export const getBankTransactions = (params = {}) =>
	axiosClient.get('/api/bank-transactions', { params });

export const createBankTransaction = (payload) =>
	axiosClient.post('/api/bank-transactions', payload);

export const updateBankTransaction = (id, payload) =>
	axiosClient.put(`/api/bank-transactions/${id}`, payload);

export const deleteBankTransaction = (id) =>
	axiosClient.delete(`/api/bank-transactions/${id}`);
